// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-width{width:calc(100% - 60px)}.sender-button{width:60px;height:60px}.send-icon{width:25px;height:25px}", ""]);
// Exports
module.exports = exports;
